import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Lock page zoom on phones. The wall does its own pinch-zoom on its element, and
// preventDefault here never stops those handlers; it only stops the browser from
// zooming or shifting the page (iOS ignores user-scalable=no).
const block = (event: Event) => event.preventDefault();
for (const type of ["gesturestart", "gesturechange", "gestureend"]) {
  document.addEventListener(type, block, { passive: false });
}
document.addEventListener(
  "touchmove",
  (event) => {
    if (event.touches.length > 1 && event.cancelable) event.preventDefault();
  },
  { passive: false },
);
// iOS can leave the layout viewport scrolled after the keyboard closes (FIND box).
document.addEventListener("focusout", () => window.scrollTo(0, 0));

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
